import { memo } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { DisclaimerType } from '../../const';
import IntlMessages from '../Message/IntlMessages';
import DisclaimerMessage from '../Message/DisclaimerMessage';
import { acceptPDPA } from 'redux/reducers/disclaimer';

const AcceptPDPA = ({
  close, actions, ...modalProps
}) => {

  const dispatch = useDispatch()

  function onAccept() {
    close();
    dispatch(acceptPDPA())
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-disclaimer">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclaimer.header.policy" />
            </h5>
            <Button className="btn button-ktb-close" onClick={close}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body">
            <DisclaimerMessage code={DisclaimerType.PDPA} dangerous />
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6">
                <div className="d-grid">
                  <Button data-accept-btn type="primary" className="btn button-ktb-main" onClick={onAccept}>
                    <IntlMessages id="global.acknowledge" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  )
}

export default memo(AcceptPDPA);